import React from 'react';
import { SearchIcon as TuuiSearchIcon } from 'tuui';

export const SearchIcon = props => {
    return <TuuiSearchIcon fontSize="small" {...props} />;
};
